// ==========================================
// API Configuration
// ==========================================
/**
 * Get the API base URL from localStorage or return default
 * @returns {string} - API base URL
 */
export const server_api = () => {
  const storedUrl = localStorage.getItem('host');
  // If it exists, return the URL from localStorage
  if (storedUrl) {
    return storedUrl;
  }
  // Otherwise, return the default URL
  // return 'http://192.168.1.2:8085';
  return 'https://api.uat.webdekho.in:8085';

};

/**
 * Set the API base URL in localStorage
 * @param {string} url - The base URL to save
 */
export const setBaseUrl = (url) => {
  if (url) {
    localStorage.setItem('host', url);
    console.log('Base URL saved:', url);
  }
};

/**
 * Clear the saved base URL from localStorage
 */
export const clearBaseUrl = () => {
  localStorage.removeItem('host');
  console.log('Base URL cleared, using default');
};

/**
 * Get current base URL (use this for API calls)
 */
export const API_BASE_URL = server_api();

// ==========================================
// App Configuration
// ==========================================
export const APP_VERSION = 7;
export const PLATFORM = "web";
